import Inventory2Outlined from '@mui/icons-material/Inventory2Outlined';
import PersonAddAlt1Outlined from '@mui/icons-material/PersonAddAlt1Outlined';
import AutoGraphOutlined from '@mui/icons-material/AutoGraphOutlined';
import PeopleAltOutlined from '@mui/icons-material/PeopleAltOutlined';
import PercentOutlined from '@mui/icons-material/PercentOutlined';
import CardGiftcardOutlined from '@mui/icons-material/CardGiftcardOutlined';
import MedicalInformationOutlined from '@mui/icons-material/MedicalInformationOutlined';
import { MODULE_PERMISSION_ENUM } from "../../Sidebar/Enum";

export const QuickLinkConfig = [
  {
    // label: 'Inventory',
    key: MODULE_PERMISSION_ENUM.INVENTORY,
    path: "/inventory",
    icon: <Inventory2Outlined />,
    isVisible: true,
  },
  {
    // label: 'Performance',
    key: MODULE_PERMISSION_ENUM.NETWORK_PERFORMANCE,
    path: "/my-performance/network-performance",
    icon: <AutoGraphOutlined />,
    isVisible: true,
  },
  {
    // label: 'My Rewards',
    key: MODULE_PERMISSION_ENUM.MY_REWARDS,
    path: "/benefits/rewards",
    icon: <CardGiftcardOutlined />,
    isVisible: true,
  },
  {
    // label: 'Beneficiary',
    key: MODULE_PERMISSION_ENUM.BENEFICIARY,
    path: "/beneficiary",
    icon: <PeopleAltOutlined />,
    isVisible: true,
  },
  {
    // label: 'Cumulative TDS',
    key: MODULE_PERMISSION_ENUM.CUMULATIVE_TDS,
    path: "/benefits/cumulative-tds",
    icon: <PercentOutlined />,
    isVisible: true,
  },
  {
    // label: 'FAQ',
    key: MODULE_PERMISSION_ENUM.FAQ,
    path: "/pwa-faq",
    icon: <PersonAddAlt1Outlined />,
    isVisible: true,
  },
  {
    // label: 'My Benefits',
    key: MODULE_PERMISSION_ENUM.MY_BENEFITS,
    path: "/benefits/mybenefits",
    icon: <MedicalInformationOutlined />,
    isVisible: true,
  },
  {
    // label: 'Network Rewards',
    key: MODULE_PERMISSION_ENUM.NETWORK_REWARDS,
    path: "/benefits/network-rewards",
    icon: <CardGiftcardOutlined />,
    isVisible: true,
  },
];
